module.exports = __webpack_public_path__ + "static/img/right-top-row-4.a931484a.png";